
import React from 'react'
import { FaTimes } from "react-icons/fa";
export default function MsgModal({ isOpen, closeModal, modalData }) {
    if (!modalData) return null;

    return (
        <div className={`fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50 ${isOpen ? "block" : "hidden"}`}>
            <div className=" p-6 rounded-lg max-w-[500px] w-full  bg-white divide-y divide-gray-600">
                <div className="flex justify-between items-center ">
                    <h3 className="text-lg font-bold text-[#1B4748]">توضیحات طرح اختصاصی</h3>
                    <button onClick={closeModal} className="text-red-500">
                        <FaTimes className="text-xl" />
                    </button>
                </div>

                <div className="mt-4">
                    
                    <p className='mb-2 mt-4 text-justify overflow-y-auto max-h-[7.5rem] whitespace-pre-wrap'>  
                    {modalData || "پیامی ثبت نشده است."}</p>
                </div>
            </div>
        </div>
    );

}
